import { DateObject } from '@uplift/services';
import { DateFormats } from '@uplift/constants';
import { WeekDay, WeekDayKeys } from '@uplift/types';
import { getAvailabilityTemplate } from '@uplift/api';
import { useQuery } from '@tanstack/react-query';


export const useAvailabilityOverrideData = (userId: string, date: DateObject, enabled = true) => {
  return useQuery({
    queryKey: [ 'availabilityTemplate', userId, date ] as const,
    queryFn: async () => {
      const formattedDate = date.format(DateFormats.ISO_DATE);
      const weekKey = WeekDay[date.day()] as WeekDayKeys;
      const data = await getAvailabilityTemplate({ date_from: formattedDate, date_to: formattedDate });

      return {
        currentRanges: data.overrides[formattedDate] || data.days[weekKey],
        defaultRanges: data.days[weekKey],
      };
    },
    enabled: enabled,
  });
};
